<template>
  <v-container id="login" fluid fill-height>
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 sm9 md6 lg4>
        <!-- Header -->
        <div class="text-center mb-6 brand-header">
          <div class="brand-title">Welcome</div>
          <div class="brand-subtitle">Teacher Portal</div>
        </div>

        <!-- Login Card -->
        <v-card class="login-card" elevation="0">
          <div class="card-top-accent"></div>

          <v-card-text class="pa-6">
            <!-- You can keep router-view as-is -->
            <router-view />
          </v-card-text>

          <v-divider class="mx-6" />

          <v-card-text class="px-6 py-4 footer-text">
            <span class="muted">Secure sign-in</span>
            <span class="dot">•</span>
            <span class="muted">Powered by Taleem</span>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import authService from "./store.js";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";

export default {
  name: "authentication",
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("auth", authService);

    const loginToken = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}token`
    );
    if (loginToken) this.$router.push({ path: "/" });
  },
};
</script>

<style scoped>
/* Full background */
#login {
  position: relative;
  overflow: hidden;
  background: radial-gradient(1200px 800px at 20% 20%, rgba(255, 255, 255, 0.35), transparent 55%),
    radial-gradient(900px 700px at 80% 30%, rgba(255, 255, 255, 0.18), transparent 60%),
    linear-gradient(135deg, #0b3d2e 0%, #0f6b4a 45%, #1aa37a 100%);
}

/* Subtle Islamic geometric pattern overlay (inline SVG as data URI) */
#login::before {
  content: "";
  position: absolute;
  inset: 0;
  opacity: 0.12;
  pointer-events: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='240' viewBox='0 0 240 240'%3E%3Cg fill='none' stroke='%23FFFFFF' stroke-width='2'%3E%3Cpath d='M120 10 L150 60 L210 60 L160 100 L180 160 L120 125 L60 160 L80 100 L30 60 L90 60 Z'/%3E%3Cpath d='M120 40 L140 75 L180 75 L148 98 L160 135 L120 112 L80 135 L92 98 L60 75 L100 75 Z'/%3E%3C/g%3E%3C/svg%3E");
  background-size: 220px 220px;
  background-repeat: repeat;
}

/* Soft vignette */
#login::after {
  content: "";
  position: absolute;
  inset: -80px;
  background: radial-gradient(circle at 50% 35%, transparent 35%, rgba(0, 0, 0, 0.32) 100%);
  pointer-events: none;
}

/* Header text */
.brand-header {
  position: relative;
  z-index: 1;
}
.brand-title {
  font-size: 44px;
  font-weight: 800;
  letter-spacing: 0.3px;
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}
.brand-subtitle {
  margin-top: 6px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}

/* Card */
.login-card {
  position: relative;
  z-index: 1;
  border-radius: 22px;
  overflow: hidden;

  /* Glass effect */
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.24);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.28);
}

/* Top accent strip */
.card-top-accent {
  height: 6px;
  background: linear-gradient(90deg, #ffd76d 0%, #ffffff 45%, #7fffd4 100%);
  opacity: 0.9;
}

/* Footer */
.footer-text {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.muted {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  font-weight: 600;
}
.dot {
  color: rgba(255, 255, 255, 0.75);
}
</style>